"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uaeDate = uaeDate;
exports.addDays = addDays;
exports.uaeTime = uaeTime;
exports.escalationTimes = escalationTimes;
// UAE time helpers. The UAE has no daylight saving: always UTC+4.
const UAE_OFFSET_MS = 4 * 3_600_000;
/** The UAE calendar date of a moment, as YYYY-MM-DD. */
function uaeDate(at = new Date()) {
    return new Date(at.getTime() + UAE_OFFSET_MS).toISOString().slice(0, 10);
}
/** YYYY-MM-DD plus n days. */
function addDays(date, days) {
    const d = new Date(`${date}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() + days);
    return d.toISOString().slice(0, 10);
}
/** The moment it is `hour`:00 in the UAE on that date. */
function uaeTime(date, hour) {
    return new Date(Date.parse(`${date}T00:00:00Z`) + hour * 3_600_000 - UAE_OFFSET_MS);
}
/**
 * Escalation times for a failed parcel (plan 4.3, 5.8; D-0020): hub manager the next time it
 * is `deadlineHour`:00 in the UAE after the failure (22:00 = the same evening, or the next
 * evening for a failure after 22:00); Ops manager `opsAfterHours` later still without a decision.
 */
function escalationTimes(failedAt, deadlineHour, opsAfterHours) {
    const sameDay = uaeTime(uaeDate(failedAt), deadlineHour);
    const hubManagerAt = sameDay > failedAt ? sameDay : uaeTime(addDays(uaeDate(failedAt), 1), deadlineHour);
    return { hubManagerAt, opsManagerAt: new Date(hubManagerAt.getTime() + opsAfterHours * 3_600_000) };
}
//# sourceMappingURL=time.js.map